import { render, staticRenderFns } from "./store-list.vue?vue&type=template&id=1df70198&"
import script from "./store-list.vue?vue&type=script&lang=js&"
export * from "./store-list.vue?vue&type=script&lang=js&"
import style0 from "./store-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports